(function () {
  function initColorCompare(slider) {
    var clip = slider.querySelector('[data-color-compare-clip]');
    var handle = slider.querySelector('[data-color-compare-handle]');
    if (!clip || !handle) return;

    var dragging = false;

    function setPosition(percent) {
      percent = Math.min(100, Math.max(0, percent));
      clip.style.clipPath = 'inset(0 0 0 ' + percent + '%)';
      handle.style.left = percent + '%';
      handle.setAttribute('aria-valuenow', Math.round(percent));
    }

    function positionFromEvent(clientX) {
      var rect = slider.getBoundingClientRect();
      var percent = ((clientX - rect.left) / rect.width) * 100;
      setPosition(percent);
    }

    function onPointerMove(evt) {
      if (!dragging) return;
      var clientX = evt.touches ? evt.touches[0].clientX : evt.clientX;
      positionFromEvent(clientX);
    }

    function onPointerUp() {
      dragging = false;
    }

    handle.addEventListener('pointerdown', function () {
      dragging = true;
    });
    slider.addEventListener('pointerdown', function (evt) {
      dragging = true;
      positionFromEvent(evt.clientX);
    });
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);

    handle.addEventListener('keydown', function (evt) {
      var current = parseFloat(handle.style.left) || 50;
      if (evt.key === 'ArrowLeft') {
        setPosition(current - 5);
        evt.preventDefault();
      } else if (evt.key === 'ArrowRight') {
        setPosition(current + 5);
        evt.preventDefault();
      }
    });

    setPosition(50);
  }

  function init() {
    document.querySelectorAll('[data-color-compare-slider]').forEach(initColorCompare);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();